import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum CoursePresenceState {
    PRESENT,
    ABSENT_WITH_PERMISSION,
    ABSENT_WITHOUT_PERMISSION,
}

export namespace CoursePresenceState {
    type Data = {
        text: string;
        icon: string;
        iconColor?: string;
    }

    export const Record: Record<CoursePresenceState, Data> = {
        [CoursePresenceState.PRESENT]: {
            text: 'Anwesend',
            icon: 'mdi-check',
            iconColor: 'success',
        },
        [CoursePresenceState.ABSENT_WITH_PERMISSION]: {
            text: 'Entschuldigt',
            icon: 'mdi-exclamation',
            iconColor: 'warning',
        },
        [CoursePresenceState.ABSENT_WITHOUT_PERMISSION]: {
            text: 'Unentschuldigt',
            icon: 'mdi-alert-outline',
            iconColor: 'error',
        },
    }

    export const Items = mapRecordToItems(Record);
}

